import { render, staticRenderFns } from "./advisoryDetail.vue?vue&type=template&id=412f4a5a&"
import script from "./advisoryDetail.vue?vue&type=script&lang=js&"
export * from "./advisoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports